import * as React from 'react';
import '../Assets/Footer.sass';

const FooterItem = (props) => {

    const { url, childComp } = props;
    return (
        <a href={url} style={{ textDecoration: "none" }}>
            <p
                className="text-center m-0 px-1 px-md-0"
                style={{ color: "#0E0E1D", fontFamily: "poppins", fontSize: "16px" }}
            >
                {childComp}
            </p>
        </a>
    );


}
export default FooterItem;